__turbopack_context__.v({
  "actionBtn": "products-module__E8alaG__actionBtn",
  "actionsRow": "products-module__E8alaG__actionsRow",
  "addBtn": "products-module__E8alaG__addBtn",
  "container": "products-module__E8alaG__container",
  "controlsRow": "products-module__E8alaG__controlsRow",
  "dateLine": "products-module__E8alaG__dateLine",
  "detailLink": "products-module__E8alaG__detailLink",
  "editPanel": "products-module__E8alaG__editPanel",
  "emptyState": "products-module__E8alaG__emptyState",
  "emptySubtitle": "products-module__E8alaG__emptySubtitle",
  "emptyTitle": "products-module__E8alaG__emptyTitle",
  "filterBtn": "products-module__E8alaG__filterBtn",
  "illustrationBlob": "products-module__E8alaG__illustrationBlob",
  "illustrationIcon": "products-module__E8alaG__illustrationIcon",
  "inlineCheck": "products-module__E8alaG__inlineCheck",
  "listSection": "products-module__E8alaG__listSection",
  "metaLine": "products-module__E8alaG__metaLine",
  "modalContent": "products-module__E8alaG__modalContent",
  "modalForm": "products-module__E8alaG__modalForm",
  "modalOverlay": "products-module__E8alaG__modalOverlay",
  "modalRow": "products-module__E8alaG__modalRow",
  "priceBox": "products-module__E8alaG__priceBox",
  "productActions": "products-module__E8alaG__productActions",
  "productMain": "products-module__E8alaG__productMain",
  "productPreview": "products-module__E8alaG__productPreview",
  "productPreviewFallback": "products-module__E8alaG__productPreviewFallback",
  "productPreviewImg": "products-module__E8alaG__productPreviewImg",
  "productRow": "products-module__E8alaG__productRow",
  "searchBox": "products-module__E8alaG__searchBox",
  "searchIcon": "products-module__E8alaG__searchIcon",
  "searchInput": "products-module__E8alaG__searchInput",
  "statusTag": "products-module__E8alaG__statusTag",
  "submitBtn": "products-module__E8alaG__submitBtn",
  "tabActive": "products-module__E8alaG__tabActive",
  "tabBtn": "products-module__E8alaG__tabBtn",
  "tabsWrapper": "products-module__E8alaG__tabsWrapper",
  "typeTag": "products-module__E8alaG__typeTag",
  "updateBtn": "products-module__E8alaG__updateBtn",
});
